import Vue from 'vue'

import {
   DropdownMenu, 
   DropdownItem,
   List,
   Tab,
   Tabs,
   Uploader,  
   Icon,
   PullRefresh,
   Cell,
   CellGroup,
   Divider,
   Empty,
   NavBar,
   Calendar,
   Toast,
   DatetimePicker,
   Dialog,
   RadioGroup,
   Radio,
   Step,
   Steps,
   Field,
   Switch,
   Popup,
   Grid,
   GridItem,
   Button,
   Picker,
   Col, 
   Row,
   Tabbar,
   TabbarItem,
   Checkbox, 
   CheckboxGroup
} from "vant";

Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(List)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Uploader)
Vue.use(Icon)
Vue.use(PullRefresh)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Divider)
Vue.use(Empty)
Vue.use(NavBar)
Vue.use(Calendar)
Vue.use(Toast)
Vue.use(DatetimePicker)
Vue.use(Dialog)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Step)
Vue.use(Steps)
Vue.use(Field)
Vue.use(Switch)
Vue.use(Popup)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Button)
Vue.use(Picker)
Vue.use(Col)
Vue.use(Row)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)